<template>
  <v-list-item class="px-0 py-3 d-flex flex-column">
    <v-list-item-title class="insights-filter-title">{{ $t('insights.filters.currencies')}}</v-list-item-title>
    <v-row class="pb-1 pt-3 full-width">
      <v-col
      v-for="(currency, index) in currencies"
      :key="index"
      class="pa-0 px-1"
      cols="4"
      >
      <v-checkbox
      v-model="selectedCurrenciesModel"
      :value="currency"
      dense
      >
      <template v-slot:label>
        <span class="insights-filter-text">{{ currency.code }}</span>
      </template>
    </v-checkbox>
  </v-col>
</v-row>
</v-list-item>
</template>

<script>
export default {
  name: 'CurrenciesFilter',
  props: {
    currencies: {
      type: Array,
      required: true,
      default: () => []
    },
    selectedCurrencies: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  emits: ['selectedCurrenciesInput'],
  computed: {
    selectedCurrenciesModel: {
      get () {
        return this.selectedCurrencies
      },
      set (value) {
        this.$emit('selectedCurrenciesInput', value)
      }
    }
  }
}
</script>

<style>
</style>
